import Shuffle from 'shufflejs';

const galleryGrid = document.getElementById('gallery-grid');
const sortSelect = document.getElementById('gallery-sort-form');
const catalogueSelect = document.getElementById('gallery-catalogue-form');
const lightbox = document.querySelector('.lightbox');
const lightboxImageContainer = document.getElementById('lightbox-image-container');

const previousImageButton = document.getElementById('previous-image-button');
const imageVersionButton = document.getElementById('image-version-button');
const nextImageButton = document.getElementById('next-image-button');

const imageElement = document.getElementById('lightbox-image');
const originalImageElement = document.getElementById('lightbox-original-image');

const lightboxCloseButton = document.getElementById('lightbox-close-button');
lightboxCloseButton.addEventListener('click', () => {
    lightbox.classList.remove('visible');
    lightboxImageIndex = null;
    lightboxImageVersion = null;
});

const lightboxQuestion = document.getElementById('lightbox-question');
const lightboxAnswer = document.getElementById('lightbox-answer');
const lightboxCueCard = document.getElementById('lightbox-cue-card');
const lightboxLikes = document.getElementById('lightbox-likes');

const loadingScreen = document.getElementById('loading-screen');

let imageData = [];
let shuffleInstance = null;

let currentSort = sortSelect.value;
let currentCatalogue = catalogueSelect.value;

let likedImageIds = new Set();

function showLoadingScreen() {
    loadingScreen.classList.remove('hidden');
    galleryGrid.classList.add('hidden');
}

function hideLoadingScreen() {
    loadingScreen.classList.add('hidden');
    galleryGrid.classList.remove('hidden');
    shuffleInstance.update();
}

function updateLikesOnServer(imageId, action = 'like') {
    // action can be 'like' or 'dislike'
    fetch(`https://publictwin.info/EngagementAppPrototypes/PromptarePlacemakingWeekPHP/Like_Gallery_Image.php` +
        `?id=${encodeURIComponent(imageId)}&action=${encodeURIComponent(action)}`)
        .then(response => response.json())
        .then(data => {
            // console.log('Server response for like action:', data);
        })
        .catch(error => {
            console.error('Error updating like on server:', error);
        });
}

// Load from sessionStorage
function loadLikedImages() {
    const raw = sessionStorage.getItem('likedImageIds');
    if (raw) {
        likedImageIds = new Set(JSON.parse(raw));
    }
}

loadLikedImages();

// Save to sessionStorage
function saveLikedImages() {
    sessionStorage.setItem('likedImageIds', JSON.stringify([...likedImageIds]));
}

sortSelect.addEventListener('change', (e) => {
    currentSort = e.target.value;
    sortImages();
});

function sortImages() {
    if (currentSort === 'new-to-old') {
        shuffleInstance.sort({ by: el => new Date(el.dataset.generated_at), reverse: true });
        return;
    }
    if (currentSort === 'old-to-new') {
        shuffleInstance.sort({ by: el => new Date(el.dataset.generated_at) });
        return;
    }
    if (currentSort === 'most-liked') {
        shuffleInstance.sort({ by: el => parseInt(el.dataset.likes, 10), reverse: true });
        return;
    }
    if (currentSort === 'least-liked') {
        shuffleInstance.sort({ by: el => parseInt(el.dataset.likes, 10) });
        return;
    }
}

function filterCatalogue() {
    if (currentCatalogue === 'all-places') {
        // show all
        shuffleInstance.filter();
        return;
    }
    shuffleInstance.filter(el => el.dataset.question_id === currentCatalogue);
}

catalogueSelect.addEventListener('change', (e) => {
    currentCatalogue = e.target.value;
    filterCatalogue();
});

function likeClicked(imageId) {
    const item = imageData.find(img => img.id === imageId);
    if (!item) return;

    const div = item.domElement;
    const likes = div.querySelector('.likes-count');
    let action = '';

    if (likedImageIds.has(imageId)) {
        likedImageIds.delete(imageId);
        item.number_of_likes -= 1;
        action = 'dislike';
    } else {
        likedImageIds.add(imageId);
        item.number_of_likes += 1;
        action = 'like';
    }

    likes.textContent = `❤️ ${item.number_of_likes}`;
    div.dataset.likes = item.number_of_likes;

    saveLikedImages();
    updateLikesOnServer(imageId, action);

    // // Re-sort if currently sorted by likes
    // if (currentSort === 'most-liked' || currentSort === 'least-liked') {
    //     sortImages();
    // }
}

export function fetchGalleryImages() {
    const ip = localStorage.getItem('userIP') || '';
    const uid = localStorage.getItem('userUID') || '';

    const url = `https://publictwin.info/EngagementAppPrototypes/PromptarePlacemakingWeekPHP/Get_Gallery_Images.php` +
        `?ip=${encodeURIComponent(ip)}&uid=${encodeURIComponent(uid)}`;

    fetch(url)
        .then(response => response.json())
        .then(data => {
            const notYetGeneratedCount = data.filter(img => !img.generated_image || img.generated_image.trim() === '-').length;

            if (notYetGeneratedCount > 0) {
                setTimeout(fetchGalleryImages, 5000);
            }

            const newImageData = data.filter(img => img.generated_image && img.generated_image.trim() !== '-');

            if (imageData.length !== newImageData.length) {
                imageData = newImageData;
                renderGallery();
            }
        })
        .catch(error => {
            console.error('Error fetching gallery images:', error);
        });
}

function nextImage() {
    const sortedItems = shuffleInstance.sortedItems;
    const currentSortedIndex = sortedItems.findIndex(item => {
        const el = item.element;
        return parseInt(el.dataset.id, 10) === imageData[lightboxImageIndex].id;
    });
    if (currentSortedIndex === -1 || currentSortedIndex === sortedItems.length - 1) return;
    const nextEl = sortedItems[currentSortedIndex + 1].element;
    const nextId = parseInt(nextEl.dataset.id, 10);
    const nextIndex = imageData.findIndex(img => img.id === nextId);

    if (nextIndex === -1) return;

    openImage(nextIndex);
}

function previousImage() {
    const sortedItems = shuffleInstance.sortedItems;
    const currentSortedIndex = sortedItems.findIndex(item => {
        const el = item.element;
        return parseInt(el.dataset.id, 10) === imageData[lightboxImageIndex].id;
    });
    if (currentSortedIndex <= 0) return;
    const prevEl = sortedItems[currentSortedIndex - 1].element;
    const prevId = parseInt(prevEl.dataset.id, 10);
    const prevIndex = imageData.findIndex(img => img.id === prevId);

    if (prevIndex === -1) return;

    openImage(prevIndex);
}

// The index of the currently displayed image in the lightbox (in the imageData array)
let lightboxImageIndex = null;
let lightboxImageVersion = null;

function openImage(imageIndex, version = 'generated') {
    const image = imageData[imageIndex];
    if (!image) return;

    lightboxImageIndex = imageIndex;
    lightboxImageVersion = version;

    lightbox.classList.add('visible');

    imageElement.src = image.generated_image;
    imageElement.onclick = (event) => {
        event.stopPropagation();
        likeClicked(image.id);
        lightboxLikes.textContent = `❤️ ${image.number_of_likes}`;
    };

    lightboxLikes.textContent = `❤️ ${image.number_of_likes}`;
    originalImageElement.src = image.original_image;

    if (version !== 'generated') {
        imageElement.classList.add('transparent');
        lightboxLikes.classList.add('transparent');
    } else {
        imageElement.classList.remove('transparent');
        lightboxLikes.classList.remove('transparent');
    }

    imageVersionButton.textContent = version === 'original' ? 'see generated' : 'see original';

    previousImageButton.style.visibility = 'visible';
    nextImageButton.style.visibility = 'visible';

    const sortedIndex = shuffleInstance.sortedItems.findIndex(item => {
        const el = item.element;
        return parseInt(el.dataset.id, 10) === image.id;
    });

    // Hide buttons if at the ends
    if (sortedIndex === -1 || sortedIndex === shuffleInstance.sortedItems.length - 1) {
        nextImageButton.style.visibility = 'hidden';
    }
    if (sortedIndex <= 0) {
        previousImageButton.style.visibility = 'hidden';
    }

    // Update answer and cue card
    //lightboxQuestion.textContent = image.question_id;
    lightboxAnswer.textContent = image.answer_text;
    lightboxCueCard.textContent = image.trigger_text;
}

previousImageButton.addEventListener('click', (event) => {
    event.stopPropagation();
    if (lightboxImageIndex === null) return;
    previousImage();
});

nextImageButton.addEventListener('click', (event) => {
    event.stopPropagation();
    if (lightboxImageIndex === null) return;
    nextImage();
});

imageVersionButton.addEventListener('click', (event) => {
    event.stopPropagation();
    if (lightboxImageIndex === null) return;

    let version;

    if (lightboxImageVersion === 'original') {
        version = 'generated';
    } else {
        version = 'original';
    }

    openImage(lightboxImageIndex, version);
});

function renderGallery() {
    console.log('Rendering gallery with data:', imageData);
    // Clear grid
    galleryGrid.innerHTML = '';

    const totalImages = imageData.length;
    let loadedImages = 0;

    if (totalImages === 0) {
        hideLoadingScreen();
    } else showLoadingScreen();

    // Create items
    imageData.forEach(item => {
        const div = document.createElement('div');
        div.classList.add('gallery-item');
        div.dataset.id = item.id;
        div.dataset.question_id = item.question_id;
        div.dataset.generated_at = item.generated_at;
        div.dataset.likes = item.number_of_likes;

        div.addEventListener('click', (event) => {
            event.stopPropagation();
            const index = imageData.findIndex(img => img.id === item.id);
            if (index !== -1) {
                openImage(index);
            }
        });

        const img = document.createElement('img');
        img.onload = () => {
            loadedImages += 1;
            if (loadedImages === totalImages) {
                hideLoadingScreen();
            }
        };
        img.src = item.generated_image;
        img.alt = `Image ${item.id}`;

        const likes = document.createElement('div');
        likes.classList.add('likes-count');
        likes.textContent = `❤️ ${item.number_of_likes}`;
        likes.addEventListener('click', (event) => {
            event.stopPropagation();
            likeClicked(item.id);
        });

        div.appendChild(img);
        div.appendChild(likes);

        galleryGrid.appendChild(div);

        item.domElement = div; // Store reference for later use
    });

    // Initialize Shuffle if not already
    if (!shuffleInstance) {
        shuffleInstance = new Shuffle(galleryGrid, {
            itemSelector: '.gallery-item',
            sizer: '.gallery-sizer',
        });
    } else {
        shuffleInstance.resetItems();
    }

    // Initial filtering and sorting
    filterCatalogue();
    sortImages();
}

// Don't fetch gallery images in Havenpark
// fetchGalleryImages();
